import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpEventType,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError, Subject, BehaviorSubject, of } from "rxjs";
import {
  catchError,
  switchMap,
  take,
  filter,
  mergeMap,
  map,
  finalize,
} from "rxjs/operators";

import { NzMessageService } from "ng-zorro-antd";

import { AuthenticationService } from "@app/_services";
import { UserToken } from "@app/_models";
import { Router } from "@angular/router";
import { LoadingService } from "./loading.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private loadingService: LoadingService,  // Inject LoadingService
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserTokenValue;
    if (currentUser && currentUser.accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.accessToken.token}`,
        },
      });
    }
  
    this.loadingService.addRequest(request);
  
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // Handle error specific to JWT processing
        return throwError(() => err);
      }),
      finalize(() => this.loadingService.removeRequest(request))
    );
  }
}